import { ca } from '@cian/analytics';

export function trackShowTenMinutesBlock() {
  ca('eventSite', {
    action: 'show',
    label: 'Banner_mort_offer',
    category: 'Mortgage',
    name: 'oldevent',
  });
}
